export const CONFIRMED = 'подтверждена';
export const NOT_CONFIRMED = 'не подтверждена';
export const MESSAGE =
  'Чтобы подтвердить почту, зайдите в свой электронный ящик и пройдите по ссылке из письма от нас.';



// WEBPACK FOOTER //
// ./src/pages/profile/views/settings/components/info/consts.ts